import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Car, Check, X, Loader2, Search } from "lucide-react";
import api from "../../services/api";
import LicensePlateInput from "../../components/LicensePlateInput";
import { useAuth } from "../../context/AuthContext";

const KEY = "kts_last_plate";

export const VehicleCompat = ({ product }) => {
  const { user } = useAuth();
  const [plate, setPlate] = useState(() => localStorage.getItem(KEY) || "");
  const [input, setInput] = useState("");
  const [vehicles, setVehicles] = useState([]);
  const [state, setState] = useState(null);

  useEffect(() => { if (user) api.get("/me/vehicles").then(({ data }) => setVehicles(data)).catch(() => {}); else setVehicles([]); }, [user]);
  useEffect(() => {
    if (!plate) { setState(null); return; }
    setState({ loading: true });
    api.get(`/vehicle/${encodeURIComponent(plate)}/parts`, { params: { category: product.category } })
      .then(({ data }) => setState({ vehicle: data.vehicle, ok: (data.products || []).some((p) => p.id === product.id) }))
      .catch(() => setState({ error: true }));
  }, [plate, product.id, product.category]);

  const choose = (p) => { const v = p.toUpperCase().replace(/\s/g, ""); setPlate(v); localStorage.setItem(KEY, v); };
  const clear = () => { setPlate(""); localStorage.removeItem(KEY); };

  if (!plate) {
    return (
      <div data-testid="vehicle-compat" className="mt-5 rounded-2xl border border-[#1E232D] bg-[#10131A] p-4">
        <div className="flex items-center gap-2 text-[13px] font-bold text-slate-50 mb-3"><Car size={16} className="text-[#FF3B3B]" /> Cette pièce est-elle compatible avec votre véhicule ?</div>
        {vehicles.length > 0 && (
          <div className="flex flex-wrap gap-2 mb-3">
            {vehicles.map((v) => <button key={v.id} data-testid={`vehicle-compat-garage-${v.id}`} onClick={() => choose(v.plate)} className="text-[12px] font-bold border border-[#2A3040] hover:border-[#E01F1F] rounded-lg px-3 py-1.5 text-slate-200 transition-colors">{v.plate} · {v.nickname || v.label || "mon véhicule"}</button>)}
          </div>
        )}
        <form onSubmit={(e) => { e.preventDefault(); if (input.trim()) choose(input); }} className="flex flex-col sm:flex-row gap-2">
          <LicensePlateInput testid="vehicle-compat-input" className="flex-1 scale-90 origin-left" value={input} onChange={(e) => setInput(e.target.value.toUpperCase())} />
          <button data-testid="vehicle-compat-check" type="submit" className="btn-orange rounded-xl px-5 py-2.5 font-bold inline-flex items-center justify-center gap-2 active:scale-[0.98]"><Search size={16} /> Vérifier</button>
        </form>
      </div>
    );
  }
  const cls = state?.loading ? "border-[#1E232D] bg-[#10131A]" : state?.error ? "border-red-900/60 bg-red-950/20" : state?.ok ? "border-emerald-800/60 bg-emerald-950/20" : "border-amber-800/60 bg-amber-950/20";
  return (
    <div data-testid="vehicle-compat" className={`mt-5 rounded-2xl border p-4 flex items-start gap-3 ${cls}`}>
      <div className={`w-10 h-10 shrink-0 rounded-xl flex items-center justify-center ${state?.loading ? "bg-[#181C26] text-slate-400" : state?.error ? "bg-red-900/40 text-red-300" : state?.ok ? "bg-emerald-600 text-white" : "bg-amber-600 text-white"}`}>
        {state?.loading ? <Loader2 size={18} className="animate-spin" /> : state?.error ? <X size={18} /> : state?.ok ? <Check size={20} strokeWidth={3} /> : <X size={18} />}
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-bold text-slate-50 text-[14px]" data-testid="vehicle-compat-result">
          {state?.loading ? "Vérification de la compatibilité…" : state?.error ? `Véhicule ${plate} introuvable` : state?.ok ? "Compatible avec votre véhicule" : "Compatibilité non confirmée"}
        </div>
        <div className="text-[12px] text-slate-400 mt-0.5 truncate">{state?.vehicle?.label ? `${state.vehicle.label} · ${plate}` : plate}{!state?.loading && !state?.error && <> · <Link to={`/categorie/${product.category}?plate=${encodeURIComponent(plate)}`} className="text-[#FF3B3B] hover:underline">voir toutes les pièces compatibles</Link></>}</div>
      </div>
      <button data-testid="vehicle-compat-change" onClick={clear} className="text-[12px] font-bold text-slate-400 hover:text-white shrink-0">Changer</button>
    </div>
  );
};

export default VehicleCompat;
